import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import BrowserWatcher from '@finam/browser-watcher';
import { v1 as uuid } from 'uuid';
import { AuthProvider_HashType } from '@finam/txservices-auth/proto';
import { buildStorageKey } from './utils/storage';
import { getCookie, setCookie } from './utils/cookie';
import hashWith from './utils/hashWith';
var AUTH_STAMP_KEY = 'auth-stamp';

var buildAuthStampKey = function buildAuthStampKey(env, variant, fingerprint) {
  return buildStorageKey({
    env: env,
    itemKey: AUTH_STAMP_KEY,
    params: [variant, fingerprint]
  });
};

var ACTIVE_TAB_KEY = 'active-tab';

var buildActiveTabKey = function buildActiveTabKey(env, appName) {
  return buildStorageKey({
    env: env,
    itemKey: ACTIVE_TAB_KEY,
    appName: appName
  });
};

var BrowserTabsWatcher = /*#__PURE__*/function () {
  function BrowserTabsWatcher(options) {
    var _this = this;

    _classCallCheck(this, BrowserTabsWatcher);

    this.handleAway = function () {
      var _a;

      if (((_a = _this.getActiveTab()) === null || _a === void 0 ? void 0 : _a.id) === _this.tabId) {
        _this.removeActiveTab();
      }

      if (!_this.isTabsActive()) {
        _this.onAway();
      }
    };

    this.handleActive = function () {
      var prevActiveTab = _this.getActiveTab();

      if (!_this.currentWindow.document.hidden || !prevActiveTab || prevActiveTab.id === _this.tabId || Date.now() - prevActiveTab.stamp > 3000) {
        _this.storeActiveTab(_this.tabId);

        if ((prevActiveTab === null || prevActiveTab === void 0 ? void 0 : prevActiveTab.id) !== _this.tabId) {
          _this.onActive();
        }
      }
    };

    this.env = options.env;
    this.variant = options.variant;
    this.appName = options.appName;
    this.isLoggedIn = options.isLoggedIn;
    this.onAway = options.onAway;
    this.onActive = options.onActive;
    this.activeTabKey = buildActiveTabKey(this.env, this.appName);
    this.currentWindow = options.currentWindow || window;
    this.tabId = uuid();
    this.browserWatcher = new BrowserWatcher(1000);
    this.unsubscribeBrowser = this.browserWatcher.watchBrowserConnection("auth_".concat(this.variant), this.handleAway, this.handleActive);
  }

  _createClass(BrowserTabsWatcher, [{
    key: "localStorage",
    get: function get() {
      return this.currentWindow.localStorage;
    }
  }, {
    key: "storeActiveTab",
    value: function storeActiveTab(tabId) {
      var stamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
      this.localStorage.setItem(this.activeTabKey, "".concat(tabId, ":").concat(stamp));
    }
  }, {
    key: "removeActiveTab",
    value: function removeActiveTab() {
      this.localStorage.removeItem(this.activeTabKey);
    }
  }, {
    key: "getActiveTab",
    value: function getActiveTab() {
      var activeTab = this.localStorage.getItem(this.activeTabKey) || '';

      var _activeTab$split = activeTab.split(':'),
          _activeTab$split2 = _slicedToArray(_activeTab$split, 2),
          id = _activeTab$split2[0],
          stamp = _activeTab$split2[1];

      return id ? {
        id: id,
        stamp: parseInt(stamp, 10)
      } : undefined;
    }
  }, {
    key: "getCookieAuthStampKey",
    value: function getCookieAuthStampKey() {
      return this.personFingerprint ? buildAuthStampKey(this.env, this.variant, this.personFingerprint) : undefined;
    }
  }, {
    key: "getAuthStamp",
    value: function getAuthStamp() {
      var authStampKey = this.getCookieAuthStampKey();
      var cookieValue = authStampKey && getCookie(authStampKey) || '';

      var _cookieValue$split = cookieValue.split(':'),
          _cookieValue$split2 = _slicedToArray(_cookieValue$split, 2),
          appName = _cookieValue$split2[0],
          value = _cookieValue$split2[1];

      return value ? {
        appName: appName,
        value: parseInt(value, 10)
      } : undefined;
    }
  }, {
    key: "updateAuthStamp",
    value: function updateAuthStamp() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
      var authStampKey = this.getCookieAuthStampKey();

      if (authStampKey) {
        setCookie(authStampKey, "".concat(this.appName, ":").concat(value), {
          domain: this.currentWindow.location.hostname.split('.').slice(-2).join('.'),
          'max-age': 60
        });
      }
    }
  }, {
    key: "isTabsActive",
    value: function isTabsActive() {
      var authStamp = this.getAuthStamp();

      if (!authStamp) {
        return false;
      }

      if (authStamp.appName === this.appName) {
        return !this.currentWindow.document.hidden;
      }

      return Boolean(authStamp.value && Date.now() - authStamp.value < 3000);
    }
  }, {
    key: "listen",
    value: function listen(_ref) {
      var _this2 = this;

      var personId = _ref.personId,
          authSource = _ref.authSource;

      var _a;

      if (!personId) {
        (_a = this.unsubscribeTab) === null || _a === void 0 ? void 0 : _a.call(this);
        return;
      }

      this.personFingerprint = hashWith("".concat(authSource || 0, "-").concat(personId), AuthProvider_HashType.MD5);

      if (this.unsubscribeTab) {
        return;
      }

      var intervalId = setInterval(function () {
        var _a;

        if (!_this2.isLoggedIn()) {
          (_a = _this2.unsubscribeTab) === null || _a === void 0 ? void 0 : _a.call(_this2);
          return;
        }

        if (!_this2.currentWindow.document.hidden) {
          _this2.updateAuthStamp();
        } else if (_this2.isTabsActive()) {
          _this2.handleActive();
        } else {
          _this2.handleAway();
        }
      }, 1000);

      this.unsubscribeTab = function () {
        clearInterval(intervalId);
        _this2.unsubscribeTab = undefined;
      };
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _a;

      (_a = this.unsubscribeTab) === null || _a === void 0 ? void 0 : _a.call(this);
      this.unsubscribeBrowser();
    }
  }]);

  return BrowserTabsWatcher;
}();

export { BrowserTabsWatcher as default };